export default "__VITE_ASSET__CeddiNPv__"